<script>
  import { afterUpdate, onMount } from "svelte"
  import ApplicationState from "../../../../Stores/applicationStates"
  import SinglePublish, { updateSinglePublish } from "../Stores/singlePublishStore"
  import Navbar from "../../../../Shared/Navbar/index.svelte"
  import Footer from "../../../../Shared/footer.svelte"
  import Table from "../../../../Shared/Table/table.svelte"
  import axios from "axios"
  import notify from "../../../../Script/notify"
  import { querystring, push } from "svelte-spa-router"
  import { queryStringToJSON } from "../../../../Script/queryString"
  import Filter from "../../../../Shared/filter.svelte"
  import LoadingScreen from "../Components/loadingScreen.svelte"
  import Header from "../Components/Header.svelte"
  import { getDocumentIdDetails } from "../script"
  import DocTempList from "./DocTempList.svelte"

  /**
   * @type {Boolean} - whether to disable next button or not
   */
  let apiCallBtnDisable = true

  /**
   * @type {String} - massage for loading screen
   */
  let msg = "Fetching Document templates"

  /**
   * @type {Object} - object get from window location
   */
  let query = queryStringToJSON($querystring)

  /**
   * @type {noDocumentTemplateNotify} - document template not selected notification
   */
  let noDocumentTemplateNotify = {
    close() {},
  }

  /**
   * @type {documentTemplateErrorNotify} - selected document template get method error notofication
   */
  let documentTemplateErrorNotify = {
    close() {},
  }

  /**
   * @type {Number} - how many list need to show
   */
  let limit

  /**
   * @type {Number} - which page list need to show
   */
  let page

  /**
   * @type {Number} - which order need to show (in order to date)
   */
  let sort

  /**
   * @typedef {Object} search - it contains what user want to search (searchvalue) in which parameter (searchParam)
   * @type {Object}
   * it contains what user want to search (searchvalue) in which parameter (searchParam)
   *
   * @property {String} searchvalue - what value need to search.
   * @property {String} searchParam - on which param need to show
   */
  let search = {
    searchParam: "name",
    searchvalue: "",
  }

  /**
   * @type {String} - from date of filter list
   */
  let startDate = null

  /**
   * @type {String} - to date of filter list
   */
  let endDate = null

  /**
   * @type {Object} - it consists response of document template fetch api
   */
  let docTempdata = {}

  /**
   * @type {Object} - user selected document temaplate details stored this variable
   */
  let selectedTemp = {}

  /**
   * @type {String} - what type of sort applied
   */
  let sortBy

  /**
   * @type {String} - what type of sort applied
   */
  let findPageRefreshed = false
  /**
   * @typedef {Object} signatureDetails - if the document was signed this signature detail object insert to the document metadata details
   * @type {Object}
   * if the document was signed this signature detail object insert to the document metadata details
   */
  let signatureDetails = {
    "Digital signature ID": $SinglePublish.documentId,
    "Digital signature TXID": $SinglePublish.txid,
  }

  /**
   * Assign initial values
   */
  onMount(async () => {
    setTimeout(async () => {
      try {
        apiCallBtnDisable = true
        //set new documnet id details to the local storage
        // if ($SinglePublish.documentId != query.documentId) await getDocumentIdDetails()
        //fetch table filter details in the qurey
        // else {
        query = queryStringToJSON($querystring)
        limit = query.limit ? query.limit : 10
        page = query.page ? query.page : 1
        sort = query.sort ? query.sort : -1
        sortBy = query.sortBy ? query.sortBy : "date"
        if (query.sdate) startDate = query.sdate
        if (query.edate) endDate = query.edate
        if (query.sname) search.searchvalue = query.sname

        if (!findPageRefreshed) await fetchTemplates()
        // }
      } catch (error) {
        const info = "PAGE: Single Publish (Choose Document Template)\nEVENT: onMount"
        notify.danger(error, info)
      } finally {
        apiCallBtnDisable = false
      }
    }, 100)
  })

  /**
   * @description Fetches the list of document templates.
   */
  const fetchTemplates = () => {
    return new Promise(async (resolve, reject) => {
      try {
        // Fetching list of document templates
        const { data } = await axios.get(`/api/swagger/v2/templates/documents?limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}${search.searchvalue ? `&sin=${search.searchParam}&sname=${search.searchvalue}` : ``}${startDate ? `&sdate=${startDate}` : ``}${endDate ? `&edate=${endDate}` : ``}`, {
          headers: {
            "x-access-token": $ApplicationState.token,
          },
        })
        // Check if the response has an error and is not successful
        if (data.error && !data.success) {
          throw data.errorCode // Throw the error code
        }
        docTempdata = data
        push(`/publish/single/choose_template?documentId=${$SinglePublish.documentId}&limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}${search.searchvalue ? `&sin=${search.searchParam}&sname=${search.searchvalue}` : ``}${startDate ? `&sdate=${startDate}` : ``}${endDate ? `&edate=${endDate}` : ``}`)

        // show document templates by filtering only when they have name
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  /**
   * @description function goto metadata section.
   */
  const nextPage = async () => {
    msg = "Fetching metadata for selected document template"
    noDocumentTemplateNotify.close()
    documentTemplateErrorNotify.close()
    const info = "PAGE: Single Publish (Choose Document Template)\nEVENT: While selecting document template to proceed"
    // Check if the response has an error and is not successful
    if (!$SinglePublish.documentTemplateId) {
      noDocumentTemplateNotify = notify.danger("Choose document template", info)
    } else {
      try {
        if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
        apiCallBtnDisable = true
        // Fetching document template by ID
        const { data } = await axios.get(`/api/swagger/v2/templates/documents/${$SinglePublish.documentTemplateId}`, {
          headers: {
            "x-access-token": $ApplicationState.token,
          },
        })

        if (data.error && !data.success) throw data.errorCode // Throw the error code
        $SinglePublish.Json = JSON.parse(data.template.metadata)
        if ($SinglePublish.signedPDFName) $SinglePublish.Json.issuer = { ...$SinglePublish.Json.issuer, ...signatureDetails }
        push(`/publish/single/metadata?documentId=${$SinglePublish.documentId}`)
      } catch (error) {
        documentTemplateErrorNotify = notify.danger(error, info)
      } finally {
        apiCallBtnDisable = false
        updateSinglePublish($SinglePublish)
      }
    }
  }

  /**
   * @description Function to fetch templates based on user input.
   */
  const whileChangingEntries = async (e) => {
    try {
      apiCallBtnDisable = true
      if (e.detail.entries) limit = e.detail.entries
      if (e.detail.activePage) page = e.detail.activePage
      if (e.detail.sort) sort = e.detail.sort
      if (e.detail.sortBy) sortBy = e.detail.sortBy
      startDate = e.detail.filter.date.startDate ? e.detail.filter.date.startDate : ""
      endDate = e.detail.filter.date.endDate ? e.detail.filter.date.endDate : ""
      if (e.detail.filter.search.searchParam) {
        search.searchParam = e.detail.filter.search.searchParam
        search.searchvalue = e.detail.filter.search.searchvalue
      }
      await fetchTemplates()
    } catch (error) {
      const info = "PAGE: Single Publish (Choose Document Template)\nEVENT: Error occurred during actions such as sorting by date/ name, changing display entries, changing date filter, searching by name, or navigating pages."
      notify.danger(error, info)
    } finally {
      apiCallBtnDisable = false
    }
  }

  /**
   * @description Function to reset the user inputs
   */
  const resetList = async () => {
    try {
      apiCallBtnDisable = true
      limit = 10
      page = 1
      sort = -1
      search.searchvalue = ""
      startDate = null
      endDate = null
      await fetchTemplates()
    } catch (error) {
      const info = "PAGE: Single Publish (Choose Document Template)\nEVENT: Error occurred while resetting filter."
      notify.danger(error, info)
    } finally {
      apiCallBtnDisable = false
    }
  }

  /**
   * @description Function for save the user selected templated
   */
  const findSelectedTemplate = (json) => {
    $SinglePublish.documentTemplateId = json.id
    for (let i = 0; i < docTempdata.templates.length; i++) if (docTempdata.templates[i].id == json.id) selectedTemp = docTempdata.templates[i]
    nextPage()
  }
</script>

<svelte:window
  on:load={() => {
    findPageRefreshed = true
    push(`/publish/single?documentId=${query.documentId}`)
  }}
/>

<svelte:head>
  <title>Single Document Publish</title>
</svelte:head>

<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] dark:bg-bodyblack">
  <Navbar />
  <div class="px-6">
    <div class="mx-auto h-auto w-full max-w-[920px] pb-40 pt-6">
      <Header bind:apiCallBtnDisable bind:msg />
      <div class="relative flex min-h-[470px] flex-col justify-between rounded-md bg-white p-6 dark:bg-mdGray mobile:p-12">
        <p class="mb-3 w-full select-none break-words text-justify text-sm text-gray-200 mobile:text-base sm:w-3/4 md:text-base">Please select a document template from which data will be imported. This will help you save time by automatically populating certain fields with pre-existing data from the selected template.</p>
        <div class="h-full space-y-3">
          {#if docTempdata.templates}
            <Table on:changeEntries={whileChangingEntries} on:resetEntries={resetList} title={"Document Templates"} filterComponent={Filter} filter={true} jsonData={docTempdata.templates ? docTempdata.templates : []} count={docTempdata.count}>
              <!-- List component -->
              {#if docTempdata.templates.length}
                {#each docTempdata.templates as Json}
                  <DocTempList json={Json} on:click={() => findSelectedTemplate(Json)} />
                {/each}
              {:else}
                <div class="text-secondary2 select-none rounded-md bg-white py-6 text-center text-2xl dark:bg-darkgray dark:text-white">There is no document template</div>
              {/if}
            </Table>
          {/if}
        </div>

        {#if docTempdata.templates && !docTempdata.templates.length}
          <div class="flex w-full justify-end">
            <a href="#/templates/document/edit?id=000000000000000000000000&documentID={$SinglePublish.documentId}" type="button" class="flex h-9 w-fit min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-blue-300 lg:px-4">
              <i class="fa-solid fa-plus" />
              <span class="select-none md:block">&nbsp;Create&nbsp;Document&nbsp;Template&nbsp;&nbsp;</span>
            </a>
          </div>
        {/if}
        {#if apiCallBtnDisable}
          <LoadingScreen {msg} />
        {/if}
      </div>
    </div>
  </div>
  <Footer />
</div>
